export enum SessionModeEnum {
    LECTURE = 1, // 선생님 혼자 수업 진행
    SELF = 2, // 학생 혼자 진행
    TASK = 3, // 선생님이 지정한 학생만 비동기로 진행
}

export const sessionModeText = {
    [SessionModeEnum.LECTURE]: '수업',
    [SessionModeEnum.SELF]: '자습',
    [SessionModeEnum.TASK]: '과제',
};
